import { Card } from "../../../shared/card/card.tsx";
import styles from "./employee-view-directory.module.css";

export type EmployeeProfileField = {
  label: string;
  value: string;
  href?: string;
  wide?: boolean;
};

export function EmployeeProfileSection({ title, fields, columns = 2 }: { title: string; fields: EmployeeProfileField[]; columns?: 1 | 2 }) {
  return <Card className={styles.profileSection}>
    <h2 className="heading-xs">{title}</h2>
    <dl className={`${styles.profileFields} ${columns === 1 ? styles.profileFieldsSingleColumn : ""}`}>{fields.map((field) => <div key={field.label} className={`${styles.profileField} ${field.wide ? styles.profileFieldWide : ""}`}>
      <dt>{field.label}</dt>
      <dd>{field.href && field.value !== "-" ? <a href={field.href} target="_blank" rel="noreferrer">{field.value}</a> : field.value}</dd>
    </div>)}</dl>
  </Card>;
}
